<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    data() {
        return {
            newPassword: '',
            newPasswordConfirm: ''
        }
    },
    props: {
        userResource: {
            type: Object,
            required: true
        }
    },
    methods: {
        async onSubmit() {
            try {
                let user = await this.userResource.setPassword(this.newPassword)
                this.$emit('success', user)
            } catch(e) {
                throw this.axiosExtract(e)
            }
        },
        isValid() {
            return this.newPassword && this.newPassword === this.newPasswordConfirm
        }
    },
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-card class="mt-5" :header="!userResource.isOnboarded() ? 'Définir le mot de passe' : 'Changer le mot de passe'">
            <b-alert variant="success" v-if="!userResource.isOnboarded()" show>Vous n'avez pas encore défini de mot de passe</b-alert>
            <b-form-group label="Nouveau mot de passe :">
                <b-form-input type="password" v-model="newPassword" autocomplete="new-password" />
            </b-form-group>
            <b-form-group label="Nouveau mot de passe (encore) :">
                <b-form-input type="password" v-model="newPasswordConfirm" autocomplete="new-password" />
            </b-form-group>
            <messages />
            <template slot="footer">
                <b-button :to="{ name: 'dashboard' }" variant="link" size="sm">Annuler</b-button>
                <b-button type="submit" :disabled="!isValid()" class="float-right">Soumettre</b-button>
            </template>
        </b-card>
    </b-form>
</template>